var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15402_22607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0556 3.88932C6.8283 3.88932 5.83338 4.88425 5.83338 6.11154C5.83338 7.33884 6.8283 8.33377 8.0556 8.33377C9.2829 8.33377 10.2778 7.33884 10.2778 6.11154C10.2778 4.88425 9.2829 3.88932 8.0556 3.88932ZM4.16671 6.11154C4.16671 3.96377 5.90782 2.22266 8.0556 2.22266C10.2034 2.22266 11.9445 3.96377 11.9445 6.11154C11.9445 8.25932 10.2034 10.0004 8.0556 10.0004C5.90782 10.0004 4.16671 8.25932 4.16671 6.11154Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0556 12.7782C6.12943 12.7782 4.35467 13.8225 3.41924 15.5063L3.08297 16.1115H10.2332C10.6935 16.1115 11.0666 16.4846 11.0666 16.9449C11.0666 17.4051 10.6935 17.7782 10.2332 17.7782H2.77635C1.64311 17.7782 0.926783 16.5608 1.47714 15.5702L1.96231 14.6969C3.19169 12.484 5.52415 11.1115 8.0556 11.1115V11.9449C8.0556 11.1115 8.0556 11.1115 8.0556 11.1115L8.05819 11.1115L8.06221 11.1116L8.07442 11.1116L8.11475 11.1122C8.1484 11.1129 8.19535 11.1142 8.25312 11.1166C8.36824 11.1216 8.52859 11.1313 8.71375 11.1509C9.07055 11.1885 9.57506 11.2678 10.0295 11.448C10.4573 11.6177 10.6666 12.1021 10.4969 12.5299C10.3272 12.9577 9.84282 13.167 9.41501 12.9973C9.16917 12.8998 8.84034 12.8401 8.53889 12.8083C8.39491 12.7931 8.2699 12.7856 8.18195 12.7818C8.13818 12.7799 8.10417 12.779 8.08222 12.7786L8.05883 12.7782L8.0556 12.7782Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 11.9449C11.6667 11.4846 12.0398 11.1115 12.5 11.1115H17.5C17.9603 11.1115 18.3334 11.4846 18.3334 11.9449C18.3334 12.4051 17.9603 12.7782 17.5 12.7782H12.5C12.0398 12.7782 11.6667 12.4051 11.6667 11.9449Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5017 14.4449C12.5017 13.9846 12.8748 13.6115 13.335 13.6115H16.6683C17.1286 13.6115 17.5017 13.9846 17.5017 14.4449C17.5017 14.9051 17.1286 15.2782 16.6683 15.2782H13.335C12.8748 15.2782 12.5017 14.9051 12.5017 14.4449Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3334 16.9449C13.3334 16.4846 13.7065 16.1115 14.1667 16.1115H15.8334C16.2936 16.1115 16.6667 16.4846 16.6667 16.9449C16.6667 17.4051 16.2936 17.7782 15.8334 17.7782H14.1667C13.7065 17.7782 13.3334 17.4051 13.3334 16.9449Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15402_22607"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGender);
export default __webpack_public_path__ + "static/media/iconGender.50149a4ba43b4c7defae3d13499da022.svg";
export { ForwardRef as ReactComponent };